<template>
  <div style="padding: 30px 0px">
    <WinnerContacts />
    <WinsCustomerInfo />
    <!-- <h2 class="text-center colorblue">Реестр победителей</h2> -->
    <v-card>
      <v-data-table
        dense
        :headers="headers"
        :items="protocolData"
        :options.sync="options"
        :server-items-length="totalDesserts"
        :footer-props="{
          'items-per-page-options': [25, 50, 100],
        }"
        :loading="loading"
        loading-text="Считываем данные ..."
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-btn
              :disabled="loading"
              :loading="loading"
              outlined
              @click="beforeGo(2)"
              class="mr-2"
            >
              <v-icon>loop</v-icon>
            </v-btn>
            <v-dialog v-model="show" persistent max-width="1200px">
              <v-card>
                <v-card-title>
                  <h2 class="text-center colorblue ma mt-2">Фильтры</h2>
                </v-card-title>
                <v-card-text>
                  <v-container id="filtersModal">
                    <v-row>
                      <!-- <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="filters.my_clients"
                          label="мои клиенты"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="filters.first_win"
                          label="впервые выиграл"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="filters.purchase__notes"
                          label="закупки с заметками"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="filters.with_notes"
                          label="победители с заметками"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="filters.only_winner"
                          label="победитель единственный"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="filters.reged_in_fe"
                          label="зарегистрирован в FinExpert"
                        ></v-checkbox>
                      </v-col> -->

                      <v-col cols="12">
                        <div class="boldHeader">Вид закупки</div>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                          v-model="selectedLaw"
                          label="44-ФЗ"
                          :value="44"
                        ></v-checkbox>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                          v-model="selectedLaw"
                          label="223-Ф3"
                          :value="223"
                        ></v-checkbox>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                          v-model="selectedLaw"
                          label="615-ПП"
                          :value="615"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                          v-model="selectedLaw"
                          label="Коммерция"
                          :value="1"
                        ></v-checkbox>
                      </v-col>

                      <!-- <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          placeholder="Введите № закупки"
                          label="№ закупки"
                          v-model="filters.filter_number"
                          v-mask="rules.nomerzak"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          placeholder="Введите ИНН клиента"
                          v-model="filters.filter_inn"
                          v-mask="rules.inn12mask"
                          maxlength="12"
                          label="ИНН клиента"
                        ></v-text-field>
                      </v-col> -->
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          v-model="filters.filter_region"
                          :items="regions"
                          item-text="title"
                          item-value="region"
                          label="Регион победителя"
                          placeholder="Введите регион победителя"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="filters.filter_min_sum"
                          placeholder="Введите мин. сумму гарантии"
                          label="Мин. сумма гарантии"
                          name="filter_min_sum"
                          @keypress="OnFinSummChange($event)"
                          @focus="OnTextFielsFocus($event)"
                          @change="
                            OnChangeFinValAndFormatItValue(
                              $event,
                              'filter_min_sum'
                            )
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="filters.filter_max_sum"
                          placeholder="Введите макс сумму гарантии"
                          label="Макс. сумма гарантии"
                          class="filledColor"
                          name="filter_max_sum"
                          @keypress="OnFinSummChange($event)"
                          @focus="OnTextFielsFocus($event)"
                          @change="
                            OnChangeFinValAndFormatItValue(
                              $event,
                              'filter_max_sum'
                            )
                          "
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="Дата протокола с"
                          placeholder="Введите дату протокола c"
                          v-model="filters.date1"
                          v-mask="rules.dateMask"
                          @focus="OnTextFielsFocus($event)"
                          @blur="
                            setPickerToNewDateUniversal(
                              'date1',
                              'filter_date_from'
                            )
                          "
                        >
                          <template v-slot:append-outer>
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="true"
                              transition="scale-transition"
                              left
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-icon left v-on="on">event</v-icon>
                              </template>
                              <v-date-picker
                                first-day-of-week="1"
                                v-model="filters.filter_date_from"
                                no-title
                                @input="
                                  InputDataPickerUniversal(
                                    'date1',
                                    'filter_date_from',
                                    'menu1'
                                  )
                                "
                              ></v-date-picker>
                            </v-menu>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          id="dateTo"
                          placeholder="Введите дату протокола по"
                          label="Дата протокола по"
                          v-model="filters.date2"
                          v-mask="rules.dateMask"
                          @focus="OnTextFielsFocus($event)"
                          @blur="
                            setPickerToNewDateUniversal(
                              'date2',
                              'filter_date_to'
                            )
                          "
                        >
                          <template v-slot:append-outer>
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="true"
                              transition="scale-transition"
                              left
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-icon left v-on="on">event</v-icon>
                              </template>
                              <v-date-picker
                                first-day-of-week="1"
                                v-model="filters.filter_date_to"
                                no-title
                                @input="
                                  InputDataPickerUniversal(
                                    'date2',
                                    'filter_date_to',
                                    'menu2'
                                  )
                                "
                              ></v-date-picker>
                            </v-menu>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        style="display: flex; align-items: flex-end"
                      >
                        <v-checkbox
                          v-model="filters.not_required"
                          label="без добросовестных"
                        ></v-checkbox>
                      </v-col>
                      <!-- <v-col cols="12" sm="6" md="4">
                        <v-select
                          placeholder="Последние 5 минут"
                          label="Время добавления на сервер"
                          v-model="filters.selectedAddTime"
                          :items="optionsAddTime"
                        ></v-select>
                      </v-col> -->
                      <v-col xs="12" sm="6" md="4" lg="4">
                        <v-btn
                          small
                          outlined
                          @click="onToday"
                          style="width: 100%"
                          >за сегодня</v-btn
                        >
                      </v-col>
                      <v-col xs="12" sm="6" md="4" lg="4">
                        <v-btn
                          small
                          outlined
                          @click="onBeforeDay"
                          style="width: 100%"
                          >за сегодня и вчера</v-btn
                        ></v-col
                      >
                      <v-col xs="12" sm="6" md="4" lg="4">
                        <v-btn
                          small
                          outlined
                          @click="onBeforeDayBefore"
                          style="width: 100%"
                          >за сегодня и вчера и позавчера
                        </v-btn></v-col
                      >
                    </v-row>
                  </v-container>
                </v-card-text>
                <!-- <v-card-text>
                  <div class="text-center">
                    <v-chip
                      v-if="chip1"
                      class="ma-2"
                      close
                      color="green"
                      outlined
                      @click:close="chip1 = false"
                      >Success</v-chip
                    >
                    <v-chip
                      v-if="chip2"
                      class="ma-2"
                      close
                      color="green"
                      outlined
                      @click:close="chip2 = false"
                      >Success</v-chip
                    >
                  </div>
                </v-card-text> -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn small outlined @click="closeFiltersAndApply"
                    >Применить</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn small outlined @click="clearFilter">Очистить</v-btn>
                  <v-spacer></v-spacer>
                  <!-- <v-btn small outlined @click="show = false">Сохранить</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn small outlined @click="show = false"
                    >Восстановить</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn small outlined @click="show = false">Свернуть</v-btn>
                  <v-spacer></v-spacer> -->
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-checkbox
              class="mt-5"
              v-model="filters.filter_auto_update"
              label="автоматическое обновление"
            ></v-checkbox>-->
            <v-divider class="mx-4" inset vertical></v-divider>
            <ProtocolsCount />
            <v-divider class="mx-4" inset vertical></v-divider>
            <div
              class="onHover"
              style="width: 35px"
              title="Скачать список"
              @click="SaveList"
              v-if="protocolData.length > 0"
            >
              <img :src="XLSICON" alt="Иконка Excell" v-if="!loadingXLS" />
              <Loader v-else class="accents" width="60" />
            </div>

            <div
              class="onHover"
              style="width: 35px"
              title="Скачать CSV"
              @click="SaveListCSV"
              v-if="protocolData.length > 0 && totalDesserts < 200"
            >
              <img :src="CSVICON" alt="Иконка CSV" v-if="!loadingCSV" />
              <Loader v-else class="accents" width="60" />
            </div>

            <v-divider class="mx-4" inset vertical></v-divider>

            <!-- <v-spacer style="width: 20%;"></v-spacer> -->
            <v-text-field
              class="mt-5"
              dense
              placeholder="Введите № закупки"
              label="№ закупки"
              clearable
              v-model="filters.filter_number"
              v-mask="rules.nomerzak"
            ></v-text-field>
            <v-btn @click="beforeGo(2)" class="ml-2">Найти</v-btn>
            <v-btn @click="show = !show" class="ml-2">Фильтр</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr :class="{ marked: getClicked(item) }" @click="setClicked(item)">
            <td v-if="item.fz == 1">
              <a
                v-if="item.link"
                class="bluelink"
                :href="item.link"
                target="_blank"
                >{{ item.notificationNumber }}</a
              >
              <a v-else class="bluelink">{{ item.notificationNumber }}</a>
              <br />
              Лот: {{ item.lotNumber }}
              <br />
              <template>Коммерция</template>
              <template v-if="item.purchase && item.purchase.isSmp == true">
                <span class="ml-2" style="color: red">СМП</span>
              </template>
              <a
                v-if="item.link"
                class="ml-2 bluelink"
                :href="item.link"
                target="_blank"
                >ЕИС</a
              >
              <a v-else class="ml-2 bluelink" target="_blank">ЕИС</a>
            </td>
            <td v-else>
              <a class="bluelink" @click.prevent="showCustomerInfo(item)">{{
                item.notificationNumber
              }}</a>
              <br />
              Лот: {{ item.lotNumber }}
              <br />
              <template v-if="item.fz == 44">44-ФЗ</template>
              <template v-if="item.fz == 223">223-ФЗ</template>
              <template v-if="item.fz == 615">615-ПП</template>
              <template v-if="item.fz == 1">Коммерция</template>
              <template v-if="item.purchase && item.purchase.isSmp == true">
                <span class="ml-2" style="color: red">СМП</span>
              </template>
              <a
                class="ml-2 bluelink"
                :href="getEIS(item.notificationNumber)"
                target="_blank"
                >ЕИС</a
              >
            </td>
            <td>
              {{
                item.purchase && item.purchase.publishDate !== null
                  ? moment(
                      getNormalizeDate(item.purchase.publishDate, "en")
                    ).format("YYYY-MM-DD")
                  : "отсутствует"
              }}
              / {{ moment(item.createdAt).format("YYYY-MM-DD HH:mm") }}
              <br />
              <a
                class="bluelink"
                :href="item.purchase.href"
                target="_blank"
                v-if="item.purchase && item.purchase.href"
                >Протокол</a
              >
            </td>
            <td>
              {{ addCommas(item.price) }}
              <br />
              {{
                item.purchase && item.purchase.lowPrice
                  ? `${addCommas(item.purchase.lowPrice)}`
                  : ""
              }}
            </td>
            <td>
              <template v-if="item.purchase && item.purchase.isSmp == true"
                >&asymp;</template
              >
              {{ addCommas(item.guaranteeing) }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    :loading="false"
                    icon
                    @click="sendToCalc(item, 1, item.guaranteeing)"
                  >
                    <v-icon small v-on="on">fa fa-calculator</v-icon>
                  </v-btn>
                </template>
                <span>Переход в калькулятор</span>
              </v-tooltip>
              <br />
              <span
                v-if="
                  item.purchase &&
                  item.purchase.warranty &&
                  item.purchase.warranty.warranty_size
                "
              >
                {{ addCommas(item.purchase.warranty.warranty_size) }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      :loading="false"
                      icon
                      @click="
                        sendToCalc(
                          item,
                          2,
                          item.purchase.warranty.warranty_size
                        )
                      "
                    >
                      <v-icon small v-on="on">fa fa-calculator</v-icon>
                    </v-btn>
                  </template>
                  <span>Переход в калькулятор</span>
                </v-tooltip>
              </span>
            </td>
            <td>
              <template v-if="item.winner_inn != null">
                <span>
                  <v-tooltip bottom v-if="item.onlineParts !== null">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="onHover bluelink">{{
                        item.onlineParts !== null ? "≈" : ""
                      }}</span>
                    </template>
                    <div>Прогнозный победитель</div>
                  </v-tooltip>

                  {{ item.winner_name }}
                  <br />
                  ИНН {{ item.winner_inn }}
                </span>
                <br />
                <span
                  v-if="
                    item.purchase &&
                    item.purchase.customer &&
                    item.purchase.customer.region &&
                    item.purchase.customer.region.name
                  "
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on">location_on</v-icon>
                    </template>
                    <span>Регион</span>
                  </v-tooltip>
                  {{ item.purchase.customer.region.name }}
                </span>
                <span
                  v-if="
                    item.purchase &&
                    item.purchase.customer &&
                    item.purchase.customer.region &&
                    item.purchase.customer.region.timezone
                  "
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on">access_time</v-icon>
                    </template>
                    <span>Время победителя</span>
                  </v-tooltip>
                  {{ actualetyTime(item.purchase.customer.region.timezone) }}
                </span>
                <span v-if="item.statinfo && item.statinfo.wins">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on">emoji_events</v-icon>
                    </template>
                    <span>Количество побед</span>
                  </v-tooltip>
                  {{ item.statinfo.wins }}
                </span>
              </template>
              <template v-else>не определен</template>
            </td>
            <td>
              <template v-if="item.winner_inn !== null">
                <a @click.prevent="getWinnersContacts(item)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="mr-2" v-on="on">help</v-icon>
                    </template>
                    <span>Получить контакты победителя</span>
                  </v-tooltip>
                </a>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import XLSICON from "@/assets/xls.svg";
import CSVICON from "@/assets/csv.svg";
import { getReportUrl } from "@/components/api/localglobal.js";
import Globalrules from "@/components/api/rules.js";
import WinnerContacts from "./calcRegister/WinsWinnerContacts.vue";
import WinsCustomerInfo from "./calcRegister/WinsCustomerInfo.vue";
import ProtocolsCount from "@/components/ProtocolsCount.vue";
import moment from "moment";
import Loader from "@/components/loading.vue";
import DB from "@/plugins/db";
import { filterRegion } from "../service/filterRegion.js";

export default {
  components: {
    WinnerContacts: WinnerContacts,
    WinsCustomerInfo: WinsCustomerInfo,
    ProtocolsCount,
    Loader,
  },
  watch: {
    options: {
      handler() {
        this.beforeGo(1);
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.commit("SET_PROTOCOL_DATA", []);

    //this.beforeGo(1);
    this.setTitle("Реестр победителей");
  },
  computed: {
    /*ProtocolData() {
      return this.$store.getters.getProtocolData;
    },*/

    ProtocolData2() {
      return this.protocolData.map((n) => ({
        ...n,
        dataaddtime: n.data + " " + this.getShortDateTime(n.add_time),
        numberlot: n.number + " " + n.type,
        bgg: n.bg + " " + n.garant,
        winner_innname: n.winner_name + " " + n.winner_inn + " " + n.region,
      }));
    },
  },
  data: () => ({
    XLSICON,
    CSVICON,
    DB,
    moment,
    totalDesserts: 0,
    loadingCSV: false,
    loadingXLS: false,
    loadingGetContacts: false,
    chip1: true,
    chip2: true,
    row: true,
    legend1: "green",
    legend2: "red",
    menu1: false,
    menu2: false,
    rules: Globalrules,
    dialogAdditional: false,
    dialogCustomer: false,
    dialogWinner: false,
    dialogTZ: false,
    timeZone: "",
    regions: filterRegion,
    customerInfo: {
      title: "",
      customer_inn: "",
      customer_name: "",
    },
    winnerInfo: {
      first_win: "",
      only_one: "",
    },
    switch_filter_icon: "mdi-chevron-down",
    switch_filter_text: "Свернуть",
    protocolData: [],
    options: {
      page: 1,
      itemsPerPage: 100,
    },
    pagination: {
      page: 1,
      itemsPerPage: 100,
    },
    toggle_exclusive: null,
    search: "",
    loading: false,
    show: false,
    active: true,
    selectedLaw: [44, 223, 615, 1],
    optionsLaw: [
      { id: 0, text: "44-Ф3", value: 44 },
      { id: 1, text: "223-Ф3", value: 223 },
      { id: 2, text: "615-ПП", value: 615 },
      { id: 2, text: "Коммерция", value: 1 },
    ],
    filters: {
      my_clients: "",
      with_notes: "",
      purchase__notes: "",
      first_win: "",
      only_winner: "",
      reged_in_fe: "",
      filter_number: "",
      filter_inn: "",
      filter_region: null,
      filter_min_sum: "",
      date1: "",
      date2: "",
      filter_date_from: "",
      filter_max_sum: "",
      filter_date_to: "",
      filter_auto_update: false,
      selectedAddTime: 15,
      not_required: false,
    },

    optionsAddTime: [
      { value: null, text: "Время добавления на сервер" },
      { value: 5, text: "Последние 5 минут" },
      { value: 15, text: "Последние 15 минут" },
      { value: 30, text: "Последние 30 минут" },
      { value: 60, text: "Последний час" },
      { value: 120, text: "Последние 2 часа" },
      { value: 360, text: "Последние 6 часов" },
      { value: 1, text: "За сегодня" },
      { value: 2, text: "За целый месяц" },
    ],
    headers: [
      {
        text: "№ закупки / № лота",
        align: "left",
        filterable: false,
        sortable: false,
        value: "numberlot",
      },
      {
        text: "Дата протокола / добавления на сервер",
        align: "left",
        filterable: false,
        sortable: false,
        value: "dataaddtime",
        width: "13%",
      },
      {
        text: "НМЦ / Предложение",
        align: "left",
        filterable: false,
        sortable: false,
        value: "price",
      },
      {
        text: "Сумма обеспечения / Обеспечение гарантийных обязательств",
        align: "left",
        filterable: false,
        sortable: false,
        value: "bgg",
        width: "15%",
      },
      {
        text: "Победитель / ИНН",
        align: "left",
        filterable: false,
        sortable: false,
        value: "winner_innname",
        width: "30%",
      },
      {
        text: "Контакты победителя",
        align: "center",
        filterable: false,
        sortable: false,
        value: "contacts",
        width: "10%",
      },
      // {
      //   text: "Действия",
      //   align: "left",
      //   filterable: false,
      //   sortable: false,
      //   value: "actions"
      // }
    ],
  }),
  methods: {
    onToday() {
      this.filters.date1 = moment().format("DD.MM.YYYY");
      this.filters.date2 = moment().format("DD.MM.YYYY");
    },
    onBeforeDay() {
      this.filters.date1 = moment().subtract(1, "day").format("DD.MM.YYYY");
      this.filters.date2 = moment().format("DD.MM.YYYY");
    },
    onBeforeDayBefore() {
      this.filters.date1 = moment().subtract(2, "day").format("DD.MM.YYYY");
      this.filters.date2 = moment().format("DD.MM.YYYY");
    },

    closeFiltersAndApply() {
      this.show = false;
      this.beforeGo(2);
    },
    clearFilter() {
      this.selectedLaw = [44, 223, 615, 1];
      this.filters = {
        my_clients: "",
        with_notes: "",
        purchase__notes: "",
        first_win: "",
        only_winner: "",
        reged_in_fe: "",
        filter_number: "",
        filter_inn: "",
        filter_region: null,
        filter_min_sum: "",
        date1: "",
        date2: "",
        filter_date_from: "",
        filter_max_sum: "",
        filter_date_to: "",
        filter_auto_update: false,
        selectedAddTime: 15,
        not_required: false,
      };
    },
    async SaveList() {
      this.loadingXLS = true;
      const data = await this.$store.dispatch(
        "getWinnersListReport",
        this.protocolData
      );
      this.fileDownload(`${getReportUrl()}reports/${data.name}`);
      this.loadingXLS = false;
    },
    setClicked(item) {
      DB.save(item.number);
    },
    getClicked(item) {
      return DB.get(item.number);
    },
    actualetyTime(num) {
      num = Number(num);
      const now = moment().utcOffset(0).format();

      if (num > 0) {
        return moment(now).utcOffset(0).add(num, "hours").format("HH:mm");
      } else if (num < 0) {
        return moment(now)
          .utcOffset(0)
          .subtract(num * -1, "hours")
          .format("HH:mm");
      } else {
        return moment().utcOffset(0).format("HH:mm");
      }
    },
    correctDate(param) {
      if (!this.filters[param]) return null;
      //const [year, month, day] = param.split(".");
      const [day, month, year] = this.filters[param].split(".");
      const CurrentDate = new Date();
      let fullYear = CurrentDate.getFullYear().toString();
      let yearVar = year;
      let monthVar = month - 1;
      let dayVar = day;
      if (year.length == 2) {
        yearVar = fullYear.substr(0, 2) + year;
      }
      if (yearVar < 2000 || yearVar >= 2050) {
        yearVar = CurrentDate.getFullYear();
      }
      if (monthVar < 0 || monthVar > 11) {
        monthVar = CurrentDate.getMonth().toString().padStart(2, "0");
      }

      if (dayVar < 1 || dayVar > 31) {
        dayVar = CurrentDate.getDate().toString().padStart(2, "0");
      }

      var d = new Date(yearVar, monthVar, dayVar);

      let resulcDate =
        d.getDate().toString().padStart(2, "0") +
        "." +
        (d.getMonth() + 1).toString().padStart(2, "0") +
        "." +
        d.getFullYear().toString();

      return resulcDate;
    },
    setPickerToNewDateUniversal(dateparam, calendarparam) {
      this.filters[dateparam] = this.correctDate(dateparam);
      this.filters[calendarparam] = this.dateToCalendar(
        this.filters[dateparam]
      );
    },
    InputDataPickerUniversal(dateparam, calendarparam, menu) {
      this[menu] = false;
      this.filters[dateparam] = this.calendarToDate(
        this.filters[calendarparam]
      );
    },
    OnChangeFinValAndFormatItValue(evt, param) {
      if (evt == "") return;
      const f = (x) =>
        x.toString().includes(".") ? x.toString().split(".").pop().length : 0;
      this.filters[param] = evt;
      if (this.filters[param].indexOf(",") != -1) {
        //evt.target.value = evt.target.value.split(",").join(".");
        this.filters[param] = this.filters[param].split(",").join(".");
      }
      this.filters[param] = this.filters[param].split(" ").join("");

      var kolSimvPoslTochki = f(this.filters[param]);

      switch (kolSimvPoslTochki) {
        case 0:
          this.filters[param] = this.filters[param] + ".00";
          break;
        case 1:
          this.filters[param] = this.filters[param] + "0";
          break;
        case 2:
          break;
        default:
          this.filters[param] = Math.trunc(this.filters[param] * 100) / 100;
          this.filters[param] = parseFloat(this.filters[param]) + 0.01;
          this.filters[param] = (
            Math.trunc(this.filters[param] * 100) / 100
          ).toFixed(2);
      }
      this.filters[param] = this.filters[param]
        .toString()
        .replace(/(\d)(?=(?:\d{3})+\.)/g, "$1 ");
    },

    OnFinSummChange: function (evt) {
      //
      if (evt.key == "Enter") {
        return;
      }
      if (
        (evt.key == "." || evt.key == ",") &&
        (evt.target.value.indexOf(".") != -1 ||
          evt.target.value.indexOf(",") != -1)
      ) {
        event.preventDefault();
        return false;
      }
      var regex = new RegExp("[0-9,. ]");
      var key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },

    beforeGo(mode) {
      if (mode == 2) {
        this.$store.commit("SET_PROTOCOL_LAST_ID", "");
        this.options.page = 1;
      }
      this.go();
    },
    SaveListCSV() {
      this.loadingCSV = true;
      var dataArr = {
        date_from: this.filters.date1,
        date_to: this.filters.date2,
        number: this.filters.filter_number,
        winner_inn: this.filters.filter_inn,
        selectedAddTime: this.filters.selectedAddTime,
        min_bg: this.filters.filter_min_sum,
        max_bg: this.filters.filter_max_sum,
        law: this.selectedLaw,
        first_win: this.filters.first_win,
        only_one: this.filters.only_winner,
        region: this.filters.filter_region,
        lastID: this.$store.getters.getProtocolLastID,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        not_required: this.filters.not_required,
      };
      this.$store.dispatch("getProtocolDataCSV", dataArr).then(async (res) => {
        const blob = new Blob([res.data], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${moment().format(
          "DD_MM_YYYY_HH_mm_ss"
        )}__${this.selectedLaw.join(",")}`;
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.loadingCSV = false;
      });
    },
    go() {
      this.loading = true;
      var dataArr = {
        date_from: this.filters.date1,
        date_to: this.filters.date2,
        number: this.filters.filter_number,
        winner_inn: this.filters.filter_inn,
        selectedAddTime: this.filters.selectedAddTime,
        min_bg: this.filters.filter_min_sum,
        max_bg: this.filters.filter_max_sum,
        law: this.selectedLaw,
        first_win: this.filters.first_win,
        only_one: this.filters.only_winner,
        region: this.filters.filter_region,
        lastID: this.$store.getters.getProtocolLastID,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        not_required: this.filters.not_required,
      };
      this.$store.dispatch("getProtocolData", dataArr).then((res) => {
        const { data } = res;
        this.protocolData = data.protocols.data;
        this.totalDesserts = this.$store.getters.getProtocolDataTotal;
        this.loading = false;
      });
    },
    showAdditional(data) {
      this.$store.dispatch("showAdditional", data).then(() => {
        this.dialogAdditional = true;
      });
    },

    // dateFromMyWinsToCalc(val) {
    //   if (!val) return "";
    //   const [year, month, day] = val.split("-");
    //   return day + "." + month + "." + year;
    // },

    async sendToCalc(item, vid, summ) {
      await this.$store.dispatch("clearResults");
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "purchase_number",
        value: item.notificationNumber,
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "lot",
        value: item.lotNumber,
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "dogovor_subject",
        value: item.name,
      });
      // По просьбе Тимофея поменять местами price и нмцк
      // this.$store.dispatch("SET_CALC_PARAM", {
      //   param: "nmkc",
      //   value: item.price,
      // });

      // this.$store.dispatch("SET_CALC_PARAM", {
      //   param: "nmkc",
      //   value: item.price,
      // });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "summ",
        value: summ,
      });
      if (vid == 1) {
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "quaranteesVal",
          value: 1,
        });
      } else {
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "quaranteesVal",
          value: 4,
        });
      }

      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer",
        value:
          item.purchase &&
          item.purchase.customer &&
          item.purchase.customer.shortName
            ? item.purchase.customer.shortName
            : item.purchase.customer.fullName,
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "customer_inn",
        value:
          item.purchase && item.purchase.customer && item.purchase.customer.inn
            ? item.purchase.customer.inn
            : null,
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_inn",
        value: item.winner_inn,
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "client_name",
        value: item.winner_name,
      });
      this.$store.dispatch("SET_CALC_PARAM", {
        param: "smp",
        value:
          item.purchase && item.purchase.isSmp ? item.purchase.isSmp : false,
      });

      // this.$store.dispatch('SET_CALC_PARAM',{param: 'date5', value: this.dateFromMyWinsToCalc(item.data)})
      if (item.contractTerm && item.contractTerm.date) {
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "date5",
          value: item.contractTerm.date,
        });
      }
      if (item.fz == "44")
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "purchasesVal",
          value: 1,
        });
      else if (item.fz == "223")
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "purchasesVal",
          value: 2,
        });
      else if (item.fz == "615")
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "purchasesVal",
          value: 3,
        });

      // var data = new Date(),
      //   y = data.getFullYear(),
      //   m = (data.getMonth() + 1).toString().padStart(2, "0"),
      //   d = data.getDate().toString().padStart(2, "0");
      // this.$store.dispatch("SET_CALC_PARAM", {
      //   param: "date",
      //   value: d + "." + m + "." + y,
      // });
      // this.$store.dispatch("SET_CALC_PARAM", {
      //   param: "date2",
      //   value: "31" + "." + "01" + "." + "2021",
      // });
      // this.$store.dispatch("SET_CALC_PARAM", {
      //   param: "days",
      //   value: await this.calcDays(
      //     this.$store.getters.calc.date,
      //     this.$store.getters.calc.date2
      //   ),
      // });

      this.$store.dispatch("SetLists");

      // this.$store.dispatch("setNewCalculation"); ?

      // let routeData = this.$router.resolve({
      //   name: "calcagent",
      //   query: { id: uid },
      // });
      // window.open(routeData.href, "_blank");
      // const uid = this.genSession();
      // const uid = item.number;
      this.saveReportData(false);
      // this.$router.push({ name: "calcagent", query: { id: uid } });
      this.$router.push({ name: "calcagent" });
    },

    getDateNow(offset) {
      var today = new Date();
      var year = today.getUTCFullYear();
      var month = today.getUTCMonth();
      var day = today.getUTCDate();
      var hours = today.getUTCHours();
      var minutes = today.getUTCMinutes();

      var d = new Date(year, month, day, hours, minutes, 0);

      d.setHours(d.getHours() + offset + 3);
      var hh = d.getHours();
      var mm = d.getMinutes();
      if (hh < 10) hh = "0" + hh;
      if (mm < 10) mm = "0" + mm;
      return " " + hh + ":" + mm + " ";
    },

    getDateNowMinus(offset) {
      var today = new Date();
      var year = today.getUTCFullYear();
      var month = today.getUTCMonth();
      var day = today.getUTCDate();
      var hours = today.getUTCHours();
      var minutes = today.getUTCMinutes();

      var d = new Date(year, month, day, hours, minutes, 0);

      d.setHours(d.getHours() - offset + 3);
      var hh = d.getHours();
      var mm = d.getMinutes();
      if (hh < 10) hh = "0" + hh;
      if (mm < 10) mm = "0" + mm;
      return " " + hh + ":" + mm + " ";
    },

    getWinnerTimeFront(tz) {
      if (tz == "0" || tz == "") return this.getDateNow(0);
      if (tz[0] == "-")
        return this.getDateNowMinus(Number.parseInt(tz.slice(1)));
      if (tz[0] == "+") return this.getDateNow(Number.parseInt(tz.slice(1)));
      return this.getDateNow(Number.parseInt(tz));
    },

    showTimeZone(data) {
      this.$store.dispatch("getWinnerTime", data).then(() => {
        this.timeZone = this.$store.getters.getWinnerTime;
        this.dialogTZ = true;
      });
    },
    showWinnerInfo(data) {
      this.$store.dispatch("getWinnerinfo", data).then(() => {
        this.winnerInfo = this.$store.getters.getWinnerInfo;
        this.dialogWinner = true;
      });
    },
    getWinnersContacts(data) {
      this.loading = true;
      this.$store
        .dispatch("getWinnersContacts", data)
        .then(() => {
          this.loading = false;
          this.$store.commit("SET_SHOW_WINNERS_CONTACT_WINDOW", true);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    showCustomerInfo(item) {
      // console.log('item', item);
      // this.loading = true;
      this.$store.commit("SET_CUSTOMER_INFO_INN", item.purchase.customer.inn);
      this.$store.commit(
        "SET_CUSTOMER_INFO_NAME",
        item.purchase.customer.shortName || item.purchase.customer.fullName
      );
      this.$store.commit("SET_CUSTOMER_INFO_TITLE", item.name);

      this.$store.commit(
        "SET_CURRENT_WINNER_NUMBER_RE",
        item.notificationNumber
      );
      this.$store.commit("SET_CURRENT_WINNER_LOT_RE", item.lotNumber);
      this.$store.commit("SET_SHOW_WINNERS_CUSTOMER_WINDOW", true);
      // this.$store
      //   .dispatch("getCustomerinfo", item.number)
      //   .then(() => {
      //     this.loading = false;

      //   })
      // .catch((error) => {
      //   this.loading = false;
      //   this.$router.push("/logout");
      //   Swal.fire({
      //     icon: "error",
      //     title: "Сеанс пользователя завершен. ",
      //     text:
      //       "Время Вашей сессии истекло, для продолжения работы войдите в личный кабинет заново",
      //   });
      // });
    },
    getShortDateTime(dataString) {
      return dataString.slice(0, -3);
    },
    toggleFilter() {
      if (this.switch_filter_icon == "mdi-chevron-down") {
        this.switch_filter_icon = "mdi-chevron-up";
        this.switch_filter_text = "Развернуть";
        this.show = false;
      } else {
        this.switch_filter_icon = "mdi-chevron-down";
        this.switch_filter_text = "Свернуть";
        this.show = true;
      }
    },
    GetTableByWinnerID() {
      alert("getTableByWinnerID");
      this.loading = true;
      var law;
      if (this.selectedLaw) {
        law = this.optionsLaw.filter((item) => item.id === this.selectedLaw)[0]
          .value;
      } else {
        law = "";
      }
      var dataArr = {
        date_from: this.filter_date_from,
        date_to: this.filter_date_to,
        number: this.filter_number,
        winner_inn: this.filter_inn,
        selectedAddTime: this.selectedAddTime,
        min_bg: this.filter_min_sum,
        max_bg: this.filter_max_sum,
        law: law,
        first_win: "",
        only_one: "",
        region: this.filter_region,
        selectedGeneral: [],
      };
      this.$store.dispatch("getProtocolData", dataArr).then(() => {
        this.protocolData = this.$store.getters.getProtocolData;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.marked {
  background-color: rgba(114, 218, 67, 0.2);
}

#filtersModal {
  .col,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col-auto,
  .col-lg,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-auto,
  .col-md,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-auto,
  .col-sm,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-auto,
  .col-xl,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl-auto {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .boldHeader {
    font-weight: 700;
    font-size: 1rem;
  }

  .v-application--is-ltr .v-messages {
    min-height: 0;
    height: 0;
  }

  .v-messages {
    min-height: 0;
    height: 0;
  }

  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }

  .v-text-field__details {
    min-height: 0;
  }
}

#radios {
  .v-messages {
    min-height: 0;
  }

  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 0;
  }
}

#app {
  .theme--light.filledColor.v-input:not(.v-input--is-disabled) input {
    color: #217899;
  }

  .ma {
    margin: auto;
  }

  .headerOfPanel {
    display: block;
  }

  .v-list-item__action {
    margin-right: 2px;
  }

  .v-list--dense .v-subheader {
    height: 15px;
  }

  .v-list-item__action {
    margin: 0;
  }

  .v-card__text,
  .v-card__title {
    padding-bottom: 0;
    padding-top: 0;
  }

  .bluelink {
    color: #217899;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    .bluelinkNotInderlined {
      color: #217899;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
